(function (angular) {
  "use strict";

  angular.module('myApp').component("phoneNumber", {
    templateUrl: '/core/components/phoneNumber/phoneNumber.tpl.html',
    transclude: true,
    bindings: {
      name: '@',
      service: '=',
      required: '@',
      fax: '@'
    },
    controller: [
      '$scope','accountService',
      function ($scope, accountService) {

        $scope.$on('dataLoad', function (e) {

          if ($scope.$ctrl.service.dto[$scope.$ctrl.name + '.numberType'] == null)
            $scope.$ctrl.service.dto[$scope.$ctrl.name + '.numberType'] = 'US/Canada';
        });

        $scope.$on('memberDetail', function (e) {
          accountService.getEditProfile().then(function(resp) {
            $scope.memberData = resp.data;
            if ($scope.$ctrl.name.includes("phoneNumber") && resp.data.phoneNumber !== null && resp.data.phoneNumber !== '') {
              $scope.$ctrl.service.dto[$scope.$ctrl.name + '.number'] = resp.data.phoneNumber;
            }
            if ($scope.$ctrl.name.includes("phoneNumber") && resp.data.phoneNumberExt !== null && resp.data.phoneNumberExt !== '') {
              $scope.$ctrl.service.dto[$scope.$ctrl.name + '.ext'] = resp.data.phoneNumberExt;
            }
            if ($scope.$ctrl.name.includes("phoneNumber") && resp.data.phoneNumberType !== null && resp.data.phoneNumberType !== '') {
              $scope.$ctrl.service.dto[$scope.$ctrl.name + '.numberType'] = (resp.data.phoneNumberType === 1 ? 'US/Canada' : 'Outside US');
            }
          });
        });
      }
    ]
  });

}(window.angular));
